import { render, staticRenderFns } from "./IndexPosterJumpEdit.vue?vue&type=template&id=05dd7619&scoped=true&"
import script from "./IndexPosterJumpEdit.vue?vue&type=script&lang=js&"
export * from "./IndexPosterJumpEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd7619",
  null
  
)

export default component.exports